export default [
    "DOUBLE TIME",
    "HALF TIME",
    "KEY CHANGE",
    "SIGNATURE CHANGE",
    "POLY RHYTHM",
    "POLY METER",
    "ARPEGGIO",
    "BORROWED CHORD",
    "COUNTER POINT",
    "CHROMATIC WALK",
    "HARMONY",
    "STACCATO",
    "BUILD UP",
    "BREAK DOWN",
    "BASS DROP",
    "FADE OUT",
    "ANSWER BACKS",
    "DANCE BEAT",
    "DECEPTIVE CADENCE",
    "PLAGAL CADENCE",
    "IMPERFECT CADENCE"
]